import {
  AsyncActionState,
  asyncActionStateMatchers,
  invoke,
  setupSlice,
} from '@owl-frontend/redux';
import { fetchWikiPage } from '../../api/wiki/client';
import type { WikiPage } from '../../api/wiki/interface';

export const pageKey = (dossierId: string, path: string): string =>
  `${dossierId}::${path}`;

const fetchPage = ({
  dossierId,
  path,
}: {
  dossierId: string;
  path: string;
}): Promise<WikiPage> => fetchWikiPage(dossierId, path);

export type PageStatus = 'pending' | 'fulfilled' | 'rejected';

export interface WikiState {
  pages: {
    [key: string]: WikiPage;
  };
  // Per-page fetch status, so a failed page shows an error instead of spinning.
  status: {
    [key: string]: PageStatus;
  };
  actions: {
    fetchPage: AsyncActionState<WikiPage>;
  };
}

const initialState: WikiState = {
  pages: {},
  status: {},
  actions: {
    fetchPage: { status: 'uninitialized' },
  },
};

const slice = setupSlice('wiki', initialState)
  .addAsyncSagas({
    fetchPage: invoke(fetchPage),
  })
  .addReducers({
    'fetchPage/pending': (state, action) => {
      const { dossierId, path } = action.meta.arg;
      state.status[pageKey(dossierId, path)] = 'pending';
    },
    'fetchPage/fulfilled': (state, action) => {
      const { dossierId, path } = action.meta.arg;
      const key = pageKey(dossierId, path);
      state.pages[key] = action.payload;
      state.status[key] = 'fulfilled';
    },
    'fetchPage/rejected': (state, action) => {
      const { dossierId, path } = action.meta.arg;
      state.status[pageKey(dossierId, path)] = 'rejected';
    },
  });

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
